import { atom } from "recoil";
import { User } from "../models/User";

const UserState = atom<User | null>({
  key: "User",
  default: null,
});

export default UserState;
